module.exports = __webpack_public_path__ + "img/shujuweihu.24e738a4.png";